import { Table, Badge } from "antd";
import Layout, { Content, Header } from "antd/es/layout/layout";
import React from "react";
import check from "../../../../icons/Check.svg";
import confirm from "../../../../icons/confirm.svg";
import danger from "../../../../icons/danger.svg";
import editing from "../../../../icons/Editing.svg";
import checkAll from "../../../../icons/CheckAll.svg";
import { useNavigate } from "react-router-dom";
import moment from "jalali-moment";

function CustomPlans({ showHeader, header, planData }) {
  const navigate = useNavigate();

  const dataSource = planData?.map((data) => {
    return {
      // key: data.key,
      // name: data?..name,
      product: data?.product?.persianName,
      area: data?.area + "هکتار",
      date: moment(data?.createdAt, "YYYY/MM/DD")
        .locale("fa")
        .format("YYYY/MM/DD"),
      // location: data.location,
      state: data,
      operation: data,
    };
  });

  const columns = [
    {
      title: "نوع کشت",
      dataIndex: "product",
      key: "product",
    },
    {
      title: "مساحت",
      dataIndex: "area",
      key: "area",
    },

    {
      title: "تاریخ انجام بازدید",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "وضعیت",
      dataIndex: "state",
      key: "state",
      render: (data) => {
        if (data.status === "ARCHIVED") {
          return (
            <div className="flex flex-row-reverse justify-around shadow-sm rounded-3xl p-2">
              {" "}
              <img alt="danger" src={danger} />{" "}
              <Badge color="#F11D59" text={"عدم تایید"} />
            </div>
          );
        } else if (data.status === "COMPLETED") {
          return (
            <div className="flex flex-row-reverse justify-around shadow-sm rounded-3xl p-2">
              <img alt="checkAll" src={checkAll} />
              <Badge color="#207E4F" text={"تایید شده"} />
            </div>
          );
        } else if (
          (data.currentState === "QUESTIONNAIRE_MEAL_PLAN_WRITING") &
          (data.status === "PROCESSING")
        ) {
          return (
            <div className="flex flex-row-reverse justify-around shadow-sm rounded-3xl p-2">
              <img alt="edit" src={editing} />
              <Badge color="#E8EC18" text={"در حال نگارش"} />
            </div>
          );
        } else if (
          data.currentState === "EDUCATION_MANAGEMENT" ||
          (data.currentState === "QUESTIONNAIRE_MANAGEMENT") &
            (data.status === "PROCESSING") &
            (data.mealPlanFile !== null)
        ) {
          return (
            <div className="flex flex-row-reverse justify-around shadow-sm rounded-3xl p-2 ">
              {" "}
              <img alt="check" src={confirm} />{" "}
              <Badge color="#22FF71" text={"کنترل و تایید"} />
            </div>
          );
        } else if (
          data.currentState === "QUESTIONNAIRE_MANAGEMENT" ||
          (data.currentState === "QUESTIONNAIRE_SUPPORT") &
            (data.status === "PROCESSING") &
            (data.mealPlanFile === null)
        ) {
          return (
            <div className="flex flex-row-reverse justify-around shadow-sm rounded-3xl p-2">
              {" "}
              <img alt="check" src={check} />{" "}
              <Badge color="#9D9D9D" text={"در حال بررسی"} />
            </div>
          );
        } else {
          return (
            <Badge
              className="shadow-sm "
              style={{ width: "160px" }}
              color="#f10808"
              text="نامشخص"
            />
          );
        }
      },
    },
    {
      title: "عملیات",
      dataIndex: "operation",
      key: "operation",

      render: (data) => {
        if (data?.mealPlanFile === null) {
          return (
            <div
              style={{
                border: " 1px solid #EEE",
                borderRdivdius: "15px",
                boxShadow: "0px 2px 8px 0px rgba(219, 219, 219, 0.50)",
                padding: "4px 6px",
                borderRadius: "20px",
                width: "70%",
                margin: "auto",
                opacity: "50%",
              }}
            >
              <p>در انتظار نگارش</p>
            </div>
          );
        } else if (data?.mealPlanFile !== null) {
          return (
            <a
              style={{
                border: " 1px solid #EEE",
                borderRadius: "15px",
                boxShadow: "0px 2px 8px 0px rgba(219, 219, 219, 0.50)",
                padding: "4px 15px",
              }}
              target="_blank" rel="noreferrer"
              href={data?.mealPlanFile}
            >
              مشاهده برنامه
            </a>
          );
        } else {
          return <p>error</p>;
        }
      },
    },
  ];

  return (
    <Layout>
      <Content className="bg-white p-3 rounded-xl   max-lg:w-full">
        <Header hidden={header} className=" bg-white  font-body px-0    ">
          <div className="flex flex-row justify-between   border-solid border-2 w-full rounded-2xl px-4 items-center py-3">
            <h2 className="text-base font-normal">برنامه‌های کودی</h2>
            <button
            hidden
              onClick={() => navigate("showAllPlans")}
              className="text-center text-white text-sm font-normal bg-[#0A66C2] px-3 rounded-2xl h-7"
            >
              مشاهده همه
            </button>
          </div>
        </Header>

        <Table
         scroll={{
          x: 900,
        }}
          showHeader={showHeader}
          sticky={true}
          pagination={false}
          className="max-lg:overflow-auto max-lg:w-full text-center whitespace-nowrap "
          style={{
            fontFamily: "body",
          }}
          dataSource={dataSource}
          columns={columns}
        ></Table>
      </Content>
    </Layout>
  );
}

export default CustomPlans;
